<div class="support-page">
  <div class="support-page__header">
    <img src="assets/support-icon.png" alt="" class="support-page__header-icon" />
    <div>
      <h2 class="support-page__title">{{ 'supportPageTitle' | translate }}</h2>
      <p class="support-page__subtitle">{{ 'supportPageSubtitle' | translate }}</p>
    </div>
  </div>

  <div class="support-page__grid">
    <div class="support-card">
      <div class="support-card__icon-wrap support-card__icon-wrap--green">
        <mat-icon>email</mat-icon>
      </div>
      <h3>{{ 'supportEmailCardTitle' | translate }}</h3>
      <p>{{ 'supportEmailCardBody' | translate }}</p>
      <button mat-stroked-button class="support-card__btn">
        <mat-icon>send</mat-icon> {{ 'supportEmailButton' | translate }}
      </button>
    </div>


    <div class="support-card">
      <div class="support-card__icon-wrap support-card__icon-wrap--purple">
        <mat-icon>help_outline</mat-icon>
      </div>
      <h3>{{ 'supportFaqTitle' | translate }}</h3>
      <p>{{ 'supportFaqBody' | translate }}</p>
      <button mat-stroked-button class="support-card__btn">
        <mat-icon>menu_book</mat-icon> {{ 'supportFaqButton' | translate }}
      </button>
    </div>

    <div class="support-card">
      <div class="support-card__icon-wrap support-card__icon-wrap--red">
        <mat-icon>bug_report</mat-icon>
      </div>
      <h3>{{ 'supportBugTitle' | translate }}</h3>
      <p>{{ 'supportBugBody' | translate }}</p>
      <button mat-stroked-button class="support-card__btn">
        <mat-icon>flag</mat-icon> {{ 'supportBugButton' | translate }}
      </button>
    </div>
  </div>
</div>
